import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { patchNote, postSummary } from "../../../../services/httpClient";
import Contact from "./Contact";
import Intervention from "./Intervention";
import Referral from "./Referral";
import Standard from "./Standard";
import StudentConnections from "./StudentConnections";
import useApp from "../../../../utils/useApp";
import { User } from "../../../../types/user";
import Infraction from "./Infraction";
import Intake from "./Intake";
import Exit from "./Exit";
import CustomNote from "./CustomNote";

interface EditNoteState {
  fetchNotes: any;
  note: any;
  noteType: any;
  family: User[];
  activeFamily: User[];
  setViewNotes: any;
  setEditNote: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  saveIsEnabled: boolean;
  setSaveIsEnabled: any;
  setUserToSave: any;
  setSummary: any;
  myCase: boolean;
  setIsLoading: any;
}

const EditNote = ({
  fetchNotes,
  note,
  noteType,
  family,
  activeFamily,
  setViewNotes,
  setEditNote,
  setShowToast,
  setToastText,
  setToastBody,
  saveIsEnabled,
  setSaveIsEnabled,
  setUserToSave,
  setSummary,
  myCase,
  setIsLoading,
}: EditNoteState) => {
  const { id } = useParams();
  const { showMenu }: any = useApp();
  const [updatedNote, setUpdatedNote] = useState<any>({});
  const [docs, setDocs] = useState<any[]>([]);
  const [errMsg, setErrMsg] = useState<string>("");

  const onClickSave = () => {
    setErrMsg("");
    // if (!updatedNote.subject) {
    //   updatedNote.subject = [
    //     {
    //       id: null,
    //       type: null,
    //     },
    //   ];
    // }
    // if (updatedNote?.subject?.id?.toLowerCase() === "unassigned") {
    //   updatedNote.subject = [
    //     {
    //       id: 0,
    //     },
    //   ];
    // }

    patchNote(updatedNote, id, note?.id)
      .then(async (res: any) => {
        setIsLoading(true);

        postSummary(id)
          .then((res: any) => {
            var magic = res[0].data?.summary?.postResponse;
            setSummary(magic);
          })
          .catch((err: any) => {
            console.log(err);
          });

        setSaveIsEnabled(false);
        setUserToSave(false);
        setViewNotes(true);
        setEditNote(false);
        setShowToast(true);
        setToastText("Note Updated");
        setToastBody(note?.notetypename);
      })
      .catch((err: any) => {
        setErrMsg(err?.response?.data?.msg);
      })
      .finally(() => {
        fetchNotes();
      });
  };

  return (
    <>
      <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
        {errMsg}
      </p>
      <Card className={showMenu ? "bg-light sticky-top card-note-menu-open-sticky" : "bg-light sticky-top card-note-sticky"}>
        <Row className="pe-0 mb-3 mt-3">
          <Col className="col-6 d-flex align-items-center">
            <h5 className="app-orange-text mb-0">{note?.notetypename}</h5>
          </Col>
          <Col className="col-4"></Col>
          <Col className="col-2 d-flex justify-content-end align-items-center">
            {myCase && (
              <Button className="app-secondary-color button" onClick={() => onClickSave()} disabled={!saveIsEnabled}>
                Save
              </Button>
            )}
          </Col>
        </Row>
      </Card>

      {note?.notetype === "standard" ? (
        <Standard
          note={note}
          family={activeFamily}
          documents={docs}
          setDocuments={setDocs}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
          setShowToast={setShowToast}
          setToastText={setToastText}
          setToastBody={setToastBody}
        />
      ) : note?.notetype === "contact" ? (
        <Contact
          note={note}
          family={activeFamily}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "intervention" ? (
        <Intervention
          note={note}
          family={activeFamily}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "referral" ? (
        <Referral
          note={note}
          family={activeFamily}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "student" ? (
        <StudentConnections
          note={note}
          family={activeFamily}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "infraction" ? (
        <Infraction
          note={note}
          family={activeFamily}
          noteType={noteType}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "intake" ? (
        <Intake
          note={note}
          family={activeFamily}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "exit" ? (
        <Exit
          note={note}
          family={family}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : (
        <CustomNote
          note={note}
          family={family}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      )}
    </>
  );
};

export default EditNote;
